/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState, useRef } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import MapSearchBox from "./MapSearchBox";
import { connect } from "react-redux";
import { updateMap, updateRiders, updateRidersDirect } from "../../Redux/Map/actions";
import { ZoomControl } from "./ZoomControl";
import { closePanel, openPanel } from "../../Redux/Panels/RightPanel/actions";
import { v4 } from "uuid";
import { updateSettings } from "../../Redux/Settings/actions";

import { NEW_ORDER_STATE } from "../../Redux/Map/reducer";
import { updateRider } from "../../Redux/User/actions";
import { getAreaName } from "./mapelements";
import MapRangeChanger from "./MapRangeChanger";

var map,
	loader,
	directionsService,
	directionsRenderer,
	geocoder,
	inputPickup,
	inputDelivery,
	directionStart,
	directionEnd,
	directionTime;

loader = new Loader({
	apiKey: "AIzaSyCy1cPCttrIOD7b55qcNE5LqjQh0BvnRNc",
	version: "weekly",
	libraries: ["places"],
});

const AppMap = (props) => {
	const {
		riders = [],
		showFeatures = true,
		hideCircularMenu = false,
		configure = false,
		settings,
	} = props;

	const deliveryRoute = settings?.mapConfig?.route;
	const businessFixedLocation = settings?.mapConfig?.fixedLocation;

	const [pickupLocation, setPickupLocation] = useState();
	const [deliveryLocation, setDeliveryLocation] = useState();
	const [fixedLocation, setFixedLocation] = useState();
	const [loaded, setLoaded] = useState();
	const mapElement = useRef(null);
	const [center, setCenter] = useState({ lat: 8.9998432, lng: 7.5760102 });
	const [theme, setTheme] = useState(localStorage?.theme || "light");
	const [selectedRider, setSelectedRider] = React.useState();
	const [showSearch, setShowSearch] = React.useState(false);
	const defaultZoom = 12;

	useEffect(() => {
		if (fixedLocation && fixedLocation?.address) {
			props.updateSettings({
				mapConfig: { ...props?.settings?.mapConfig, fixedLocation },
			});
			props.updateRider({ ...props.riderform, fixedLocation });
			props?.callback && props.callback(fixedLocation)
		}
	}, [fixedLocation]);

	useEffect(() => {
		if (pickupLocation?.address) {
			displayRoute(
				pickupLocation?.address,
				deliveryLocation?.address,
				directionsService,
				directionsRenderer,
			);
			// props.updateMap({ pickupLocation });
			if(riders?.length && !selectedRider){
				refreshRidersWithLocation();
			}
		}
	}, [pickupLocation]);

	useEffect(() => {
		if (deliveryLocation?.address) {
			displayRoute(
				pickupLocation?.address,
				deliveryLocation?.address,
				directionsService,
				directionsRenderer,
			);
			// props.updateMap({ deliveryLocation });
		}
	}, [deliveryLocation]);

	function formatFixedLocationForMarker(location, address) {
		return {
			id: v4(),
			location: location,
			address: address,
			rider: {
				name: "Fixed Location",
				logo: null,
				distance: 0.3,
				location: getAreaName(address),
				openingCount: "",
				phone: "",
				website: "https://huro.cssninja.io",
				description: address,
			},
		};
	}

	function addDragEventToMarker(marker, inputPickup) {
		google.maps.event.addListener(marker, "dragend", function (event) {
			geocodePosition(event.latLng, (e, c) => {
				setFixedLocation({
					address: e,
					address_component: c,
					latLng: {
						lat: event.latLng.lat(),
						lng: event.latLng.lng()
					}
				});
				inputPickup.value = e;
			});
		});
	}

	function getZoomLevel(pointA, pointB) {
		const x = [9.0493673, 7.5133773];
		const y = [9.0324993, 7.5341693];
		const defaultDistance = Math.sqrt(
			Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2),
		);
		const defaultZoomlevel = 16.54; //defaultZoom; 9.006648, 7.543934 | 9.0125288,7.5597962
		const distance = Math.sqrt(
			Math.pow(pointA?.lat - pointB?.lat, 2) +
				Math.pow(pointA?.lng - pointB?.lng, 2),
		);
		// alert(((defaultZoomlevel * distance) / defaultDistance))
		return (defaultZoomlevel * distance) / defaultDistance;
	}

	const initMap = (inCenter = null) => {
		loader.load().then(() => {
			map = new google.maps.Map(mapElement.current, {
				center: inCenter || center,
				zoom: defaultZoom,
				disableDefaultUI: true,
				mapTypeControlOptions: {
					mapTypeIds: [google.maps.MapTypeId.ROADMAP],
				},
			});

			// Direction service
			if (!configure) {
				directionsService = new google.maps.DirectionsService();
				directionsRenderer = new google.maps.DirectionsRenderer({
					draggable: true,
					map,
					// panel: document.getElementById("panel"),
					polylineOptions: {
						strokeColor: theme === "light" ? "#37514bcc" : "#232326",
						strokeWeight: 5,
						fillOpacity: 0.5,
					},
				});
			}

			geocoder = new google.maps.Geocoder();

			// Create the search box and link it to the UI element.
			inputPickup = document.getElementById("pac-input-pickup");
			inputDelivery = document.getElementById("pac-input-delivery");
			const inputContainer = document.getElementById("pac-input-container");
			const zoomControl = document.getElementById("zoom-control");
			// const circularMenu = document.getElementById("circular-menu");
			// circularMenu.style.marginTop = 15;
			// circularMenu.style.marginRight = 15;

			const searchBoxPickup = new google.maps.places.SearchBox(inputPickup);
			const searchBoxDelivery = new google.maps.places.SearchBox(inputDelivery);
			

			map.controls[google.maps.ControlPosition.TOP_LEFT].push(inputContainer);
			// map.controls[google.maps.ControlPosition.TOP_RIGHT].push(circularMenu);

			const zoomInButton = document.getElementById("zoom-control-in");
			const zoomOutButton = document.getElementById("zoom-control-out");

			if (zoomOutButton && zoomInButton) {
				// Setup the click event listener - zoomIn
				google.maps.event.addDomListener(zoomInButton, "click", function () {
					map.setZoom(map.getZoom() + 1);
				});

				// Setup the click event listener - zoomOut
				google.maps.event.addDomListener(zoomOutButton, "click", function () {
					map.setZoom(map.getZoom() - 1);
				});
			}

			// Bias the SearchBox results towards current map's viewport.
			map.addListener("bounds_changed", () => {
				searchBoxPickup.setBounds(map.getBounds());
				searchBoxDelivery.setBounds(map.getBounds());
			});

			let markers = [];

			// Listen for the event fired when the user selects a prediction and retrieve
			// more details for that place.

			searchBoxPickup.addListener("places_changed", () => {
				const places = searchBoxPickup.getPlaces();

				if (places.length === 0) {
					return;
				}

				// Clear out the old markers.
				markers.forEach((marker) => {
					marker.setMap(null);
				});
				markers = [];

				// For each place, get the icon, name and location.
				const bounds = new google.maps.LatLngBounds();

				places.forEach((place) => {
					if (!place.geometry || !place.geometry.location) {
						console.log("Returned place contains no geometry");
						return;
					}

					if (configure) {
						geocodePosition(place.geometry.location, (e, c) => {
							setFixedLocation({
								address: e,
								address_component: c,
								latLng: {
									lat: place.geometry.location.lat(),
									lng: place.geometry.location.lng(),
								},
							});
							inputPickup.value = e;
							const mkr = makeMarker(
								formatFixedLocationForMarker(place.geometry.location, e),
							);
							markers.push(mkr);
							addDragEventToMarker(mkr, inputPickup);
							map.setCenter(place.geometry.location);
							map.setZoom(15);
						});
					} else {
						geocodePosition(place.geometry.location, (e, c) => {
							setPickupLocation({
								address: e,
								address_component: c,
								latLng: {
									lat: place.geometry.location.lat(),
									lng: place.geometry.location.lng(),
								},
							});
							inputPickup.value = e;
						});
					}
				});

				map.fitBounds(bounds);
			});
			searchBoxDelivery.addListener("places_changed", () => {
				const places = searchBoxDelivery.getPlaces();

				if (places.length === 0) {
					return;
				}

				// Clear out the old markers.
				markers.forEach((marker) => {
					marker.setMap(null);
				});
				markers = [];

				if(showFeatures){
					riders?.map((rider, i) => {
					makeMarker(rider);
				});

				}
				// For each place, get the icon, name and location.
				const bounds = new google.maps.LatLngBounds();

				places.forEach((place) => {
					if (!place.geometry || !place.geometry.location) {
						console.log("Returned place contains no geometry");
						return;
					}

					geocodePosition(place.geometry.location, (e, c) => {
						setDeliveryLocation({
							address: e,
							address_component: c,
							latLng: {
								lat: place.geometry.location.lat(),
								lng: place.geometry.location.lng(),
							},
						});

						inputDelivery.value = e;
						if (!inputDelivery.value) inputDelivery.focus();
					});
				});

				map.fitBounds(bounds);
			});

			if (directionsRenderer) {
				directionsRenderer.addListener("directions_changed", () => {
					const directions = directionsRenderer.getDirections();

					if (directions) {
						const { start_address, start_location, end_address, end_location } =
							directions.routes[0].legs[0];


						if (deliveryLocation?.address !== end_address) {
							geocodePosition(end_location, (e, c) => {
								setDeliveryLocation({
									address: e,
									address_component: c,
									latLng: {
										lat: end_location.lat(),
										lng: end_location.lng(),
									},
								});
								if (!inputDelivery.value) inputDelivery.focus();
								else inputDelivery.value = e;
							});
						}

						if (pickupLocation?.address !== start_address) {
							geocodePosition(start_location, (e, c) => {
								setPickupLocation({
									address: e,
									address_component: c,
									latLng: {
										lat: start_location.lat(),
										lng: start_location.lng(),
									},
								});
								inputPickup.value = e;
							});
						}
						computeTotalDistance(directions);
					}
				});
			}

			if (configure && props?.settings?.mapConfig?.fixedLocation?.latLng) {
				const location = props?.settings?.mapConfig?.fixedLocation?.latLng;
				const address = props?.settings?.mapConfig?.fixedLocation?.address;
				const mkr = makeMarker(formatFixedLocationForMarker(location, address));
				inputPickup.value = address;
				inputPickup.focus();
				addDragEventToMarker(mkr, inputPickup);
				map.setCenter(location);
				map.setZoom(15);
				markers.push(mkr);
			}
			props.updateMap({ ...props.map, order_no: null });

			// document.getElementById("pageloader-map").style.display = "none";// .classList.remove("is-active");
			// document.getElementById("infraloader-map").style.display = "none";// .classList.remove("is-active");
		});
	};

	function makeMarker(rider) {
		// rider?.location, rider?.rider?.logo, rider?.rider?.name
		const w = selectedRider?.id === rider?.id ? 7 : 5;
		const svgMarker = {
			path: google.maps.SymbolPath.CIRCLE,
			fillColor: "#fff",
			fillOpacity: 1,
			strokeWeight: w,
			strokeColor:
				selectedRider?.id === rider?.id
					? "#06d6a0"
					: localStorage.theme === "light"
					? "#37514b"
					: "#3b3b41f2",
			rotation: 0,
			scale: w,
		};

		const marker = new google.maps.Marker({
			position: rider?.location,
			map: map,
			title: rider?.rider?.name,
			draggable: configure ? true : false,
			icon: svgMarker,
			animation: google.maps.Animation.DROP,
		});

		const infowindow = new window.google.maps.InfoWindow({
			content: `
			<div class="mapboxgl-popup-content">
			<div class="map-box-location">
			<div class="map-box-header">
			  <div class="media-flex-center">
			  	${
						rider?.rider?.logo &&
						`<div class="h-avatar is-small">
					<img class="avatar" src="${rider?.rider?.logo}" alt="">
				  </div>`
					}
				
				<div class="flex-meta ${!rider?.rider?.logo ? "m-0" : ""}">
				  <span>${rider?.rider?.name}</span>
				  <span>${rider?.rider?.location}</span>
				</div>
			  </div>
			</div>
			<div class="map-box-body">
			  <p>${rider?.location?.address || rider?.address}</p>
			</div>
		  </div>
		  </div>
		  </div>
			`,
		});
		marker.addListener("click", () => infowindow.open(map, marker));

		return marker;
	}


	function geocodePosition(pos, callback) {
		geocoder.geocode(
			{
				latLng: pos,
			},
			function (responses) {
				if (responses && responses.length > 0) {
					callback &&
						callback(
							responses[0].formatted_address,
							responses[0].address_components,
						);
					// updateMarkerAddress();
				} else {
					console.log("Cannot determine address at this location.");
					// window.location = "?"
				}
			},
		);
	}

	function displayRoute(origin, destination, service, display) {
		if (!origin && !destination) return;
		if(origin === destination) return;
		if (service)
			service
				.route({
					origin: origin, //"Maitama, Abuja, Nigeria",
					destination: destination, //"Karu Bridge, Murtala Mohammed Rd, New Karu, Nigeria",
					waypoints: [],
					travelMode: google.maps.TravelMode.DRIVING,
					// travelMode: google.maps.TravelMode.BICYCLING,
					avoidTolls: true,
					drivingOptions: {
						departureTime: new Date(Date.now()), // for the time N milliseconds from now.
						trafficModel: google.maps.TrafficModel.BEST_GUESS,
					},
				})
				.then((result) => {
					display.setDirections(result);
				})
				.catch((e) => {
					// alert("Could not display directions due to: " + e);
				});
	}

	function computeTotalDistance(result) {
		let total = 0;
		let time = 0;
		const myroute = result.routes[0];

		if (!myroute) {
			return;
		}

		for (let i = 0; i < myroute.legs.length; i++) {
			total += myroute.legs[i].distance.value;
			time += myroute.legs[i].duration_in_traffic.value;
		}
		if (total > 0)
			// props.updateMap({ ...props?.map, order: estimatorCost(total, time) });
			props.updateMap({ ...props?.map, rider_id: selectedRider?.id, order: { distance: total/1000, time: time/60, amount: 0 } });
	}

	// Costing Data
	const estimatorCost = (distance, time) => {
		distance = distance / 1000;
		time = time / 60;

		const minimum = settings?.deliveryRate?.minimumPrice;
		let distanceRate = settings?.deliveryRate?.options?.find(
			(e) => e.key === "distance",
		);
		let timeRate = settings?.deliveryRate?.options?.find(
			(e) => e.key === "time",
		);

		const distancePrice = distanceRate?.enabled
			? (distance * distanceRate.price) / distanceRate.value
			: 0;
		const timePrice = timeRate?.enabled
			? (time * timeRate.price) / timeRate.value
			: 0;
		const bestPrice = distancePrice > timePrice ? distancePrice : timePrice;
		const price = bestPrice > minimum ? bestPrice : minimum;

		return {
			distance: distance,
			time: Math.round(time),
			amount: Math.ceil(price / 50) * 50,
		};
	};


	useEffect(() => {
		// setRiders(props?.riders || []);
		props.updateMap({ ...NEW_ORDER_STATE });
		props.updateRiders();

		getLocation((position) => {
			if (position) {
				const pos = {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				};
				initMap(pos);
				setCenter(pos);
			} else {
				initMap();
			}
		});
	}, []);

	const editInput = (name) => {
		if (name === "pickup") inputPickup.focus();
		if (name === "delivery") inputDelivery.focus();
	};

	function getLocation(callback) {
		if (
			(window.location.protocol === "https:" && navigator.geolocation) ||
			window.location.hostname === "localhost"
		) {
			try {
				navigator.geolocation.getCurrentPosition(callback);
			} catch (error) {
				callback(false);
				alert("Error message!");
			}
		} else {
			callback(false);
		}
	}

	const showOpenPanel = () => {
		
		// props?.callback && props?.callback(fixedLocation)

		if (configure && fixedLocation?.address) return true;
		if (
			pickupLocation &&
			deliveryLocation &&
			pickupLocation?.address !== deliveryLocation?.address
		) {
			return true;
		}
		return false;
	};


	// RIDER'S PANEL ACTIVITIES
	const [refreshingRiders, setRefreshingRiders] = React.useState()

	const refreshRidersWithLocation  = () => {
		setRefreshingRiders(true)
		props?.updateRiders((res) => {
			if(res?.length < 1) return;

				const service = new google.maps.DistanceMatrixService(); // instantiate Distance Matrix service
	
				const matrixOptions = {
					origins: res?.map((rider) => { return rider?.location?.lat + "," + rider?.location?.lng }), // technician locations
					destinations: [pickupLocation?.address], // customer address
					travelMode: "DRIVING",
					unitSystem: google.maps.UnitSystem.IMPERIAL,
				};
				// Call Distance Matrix service
				service.getDistanceMatrix(matrixOptions, callback);
				// Callback function used to process Distance Matrix response
				function callback(response, status) {
					if (status !== "OK") {
						alert("Error with distance matrix");
						return;
					}
	
					let routes = response.rows;
					let data = []
					res?.map((rider, i) => {
						const { duration, distance } = routes[i].elements[0];
						rider.rider.duration = duration?.value/60;
						rider.rider.distance = distance?.value/1000;
						data.push(rider);
					})

					data.sort((a,b) => (a.rider.distance > b.rider.distance) ? 1 : ((b.rider.distance > a.rider.distance) ? -1 : 0));
					if(data?.length > 0) {
						setSelectedRider(data[0]);
						props.updateMap({...props.map, rider_id: selectedRider?.id });
					}
					props?.updateRidersDirect(data);
				}
				setRefreshingRiders(false)
		})
	}

	return (
		<>
			<div
				id="mapbox-1"
				className={`map-section ${
					!showFeatures ? "remove-feature-section" : ""
				} 
				${showFeatures ? "show-rider-location" : ""}
				`}
			>
				{/* <div id={"pageloader-map"} className={`pageloader is-active`} />
				<div id={"infraloader-map"} className={`infraloader is-active`} /> */}
				<MapRangeChanger />
				<MapSearchBox
					showOpen={showOpenPanel()}
					callback={() => {
						if (configure) {
							props?.callback && props?.callback(fixedLocation)
							props?.closePanel();
							return;
						}
						props?.callback && props?.callback(fixedLocation)
					}}
					configure={configure}
					editMap={(e) => editInput(e)}
					order={props?.order}
					showSearch={showSearch}
				/>
				<ZoomControl showFeatures={showFeatures} />
				<div ref={mapElement} id="geocoder" className="geocoder" />
			</div>
		</>
	);
};

const mapStateToProps = ({ map, riders, settings, riderform }) => {
	return { map, riders: riders?.riders||[], settings, riderform };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateMap: (e) => dispatch(updateMap(e)),
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
		updateSettings: (e) => dispatch(updateSettings(e)),
		updateRiders: (e) => dispatch(updateRiders(e)),
		updateRider: (e) => dispatch(updateRider(e)),
		updateRidersDirect: (e) => dispatch(updateRidersDirect(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AppMap);
